import React from 'react';

import { Link as CoreLink } from 'core/components';

import LabelValue from 'app/views/metrics/components/LabelValue';
import isSafeExternalUrl from './isSafeExternalUrl';

const JiraCloudContextItem = ({ context, labelWidth = 150 }) => {
  const jira = context?.jira_cloud;

  if (!jira) {
    return null;
  }

  const { issue_key: issueKey, issue_url: issueUrl } = jira;

  if (!issueKey) {
    return null;
  }

  return (
    <LabelValue
      label="Jira Cloud Issue"
      labelWidth={labelWidth}
      value={
        isSafeExternalUrl(issueUrl) ? (
          <CoreLink to={issueUrl} blank rel="noopener noreferrer">
            {issueKey}
          </CoreLink>
        ) : (
          issueKey
        )
      }
    />
  );
};

export default JiraCloudContextItem;
